import { Expose, Transform } from "class-transformer";

export class CrmCustomerDto {
  @Expose()
  @Transform(({ value, obj }) => value ?? obj["accountnumber"])
  accountNumber!: string;

  @Expose()
  name!: string;

  @Expose()
  @Transform(({ value, obj }) => value ?? obj["address1_line1"])
  streetAndHouseNumber!: string;

  @Expose()
  @Transform(({ value, obj }) => value ?? obj["address1_city"])
  city!: string;

  @Expose()
  @Transform(({ value, obj }) => value ?? obj["address1_postalcode"])
  postalCode!: string;
}
